import { ExternalLink, Newspaper } from "lucide-react";
import pressBlackNews from "@/assets/press/press-blacknews-one-year.jpeg.asset.json";

const pressItems = [
  {
    outlet: "BlackNews.com",
    date: "2025",
    title:
      "Neil AI Global Solutions: Only Black-Owned AI Software & Commercial Robotics Company in North Carolina Celebrates One Year in Business",
    excerpt:
      "Founded by Albert Saunders, Neil AI Global Solutions marks its first year deploying commercial robotics and AI automation for businesses across North Carolina and the Southeast.",
    url: "https://blacknews.com/news/neil-ai-global-solutions-only-black-owned-ai-software-commercial-robotics-company-north-carolina-one-year-business/",
    image: pressBlackNews.url,
  },
];

const PressSection = () => {
  return (
    <section id="press" className="my-12 md:my-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 text-sm font-semibold text-[#D6A84F] uppercase tracking-widest mb-3">
          <Newspaper className="w-4 h-4" />
          Press &amp; Media
        </div>
        <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-foreground">
          Neil AI in the News
        </h2>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto">
          Coverage of our work building the autonomous workforce.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {pressItems.map((item) => (
          <a
            key={item.url}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group glass-effect border border-[hsl(var(--line))] rounded-2xl overflow-hidden hover:border-primary/60 transition-all hover:-translate-y-1"
          >
            <div className="aspect-[4/3] overflow-hidden bg-muted/20 p-2 sm:p-3">
              <img
                src={item.image}
                alt={`${item.outlet} feature: ${item.title}`}
                loading="lazy"
                className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-primary font-semibold mb-2">
                <span>{item.outlet}</span>
                <span className="text-muted-foreground">• {item.date}</span>
              </div>
              <h3 className="font-bold text-foreground leading-snug mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-4">{item.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#D6A84F]">
                Read the article <ExternalLink className="w-4 h-4" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default PressSection;
